import URL from 'url-parse';

import Config from './config';

let env = Config.env || (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'dev' : 'live');

let publicUrl = (new URL(Config[env].url)).origin;

let common = {
  resetDB: false,
  publicUrl: publicUrl,
  passcodeLength: 6,
  cardRatio: 1.56,
  physicalCardCost: 7.50,
  disablePasscode: true,
  maxTopUpValue: 250,
  minTopUpValue: 10
};

let configuration = {
  dev: {
    ...common,
    checkout_url: 'https://sandbox.checkout.com/api2/v2/tokens/card',
    checkout_public_key: 'pk_test_24166a6e-18f7-4405-b42a-d74aa75dc05d',
    ...Config.dev
  },
  live: {
    ...common,
    checkout_url: 'https://sandbox.checkout.com/api2/v2/tokens/card',
    checkout_public_key: 'pk_test_24166a6e-18f7-4405-b42a-d74aa75dc05d',
    ...Config.live
  }
}

const config = {

  env,

  // Preloaded configuration
  ...configuration[env]
}

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js